jQuery(document).ready(function($) {
  if($('.single-post').length > 0) {
    $('body').on('scroll resize', function() {
      console.log('bar');
      var o = $('body').scrollTop() / ($(document).height() - $('body').height());
      $('.progress-bar').css({
        'width': (100 * o | 0) + '%'
      });
      $('progress')[0].value = o;
    });
  }
  
});
